export type SectionEntry = {
  number: string
  name: string
  navLabel: string
  path: string
  summary: string
  contains: string[]
}

export const sections: SectionEntry[] = [
  {
    number: '01',
    name: 'About',
    navLabel: 'About',
    path: '/about',
    summary:
      'Who Yolandi Jardim is: professional biography, leadership philosophy and the principles that shape her executive practice.',
    contains: ['Biography', 'Leadership philosophy', 'Profile at a glance'],
  },
  {
    number: '02',
    name: 'Experiences',
    navLabel: 'Experiences',
    path: '/experiences',
    summary:
      'The industries, regulatory environments and engagement types across which she has operated as an executive.',
    contains: ['Industry exposure', 'Regulatory environments', 'Engagement types'],
  },
  {
    number: '03',
    name: 'Skills',
    navLabel: 'Skills',
    path: '/skills',
    summary:
      'Executive and human capabilities — leadership, influence, change and capability building — assessed by depth of practice.',
    contains: ['Leadership skills', 'Influence & communication', 'Change & capability'],
  },
  {
    number: '04',
    name: 'Executive Hero & Board Positioning',
    navLabel: 'Board Positioning',
    path: '/',
    summary:
      'Portrait, name, headline and the board-facing positioning statement that frames her candidacy.',
    contains: ['Portrait & headline', 'Positioning statement', 'Guiding principle'],
  },
  {
    number: '05',
    name: 'Executive Impact & Capital Metrics Grid',
    navLabel: 'Impact Metrics',
    path: '/impact',
    summary:
      'Quantified outcomes: capital deployed, assets governed, remediation closure and audit results.',
    contains: ['Headline metrics', 'Capital & scale', 'Assurance outcomes'],
  },
  {
    number: '06',
    name: 'Strategic Value Proposition & Board Competencies',
    navLabel: 'Value & Competencies',
    path: '/value-proposition',
    summary:
      'The value she brings to a board table, expressed as four leadership pillars and mapped board competencies.',
    contains: ['Value proposition', 'Four pillars', 'Board competency map'],
  },
  {
    number: '07',
    name: 'Executive Career Track Record',
    navLabel: 'Career Record',
    path: '/career',
    summary:
      'Chronological record of executive appointments, mandates held and accomplishments delivered in each.',
    contains: ['Appointments', 'Mandates', 'Accomplishments'],
  },
  {
    number: '08',
    name: 'Technical Mastery & Systems Portfolio',
    navLabel: 'Technical Mastery',
    path: '/technical',
    summary:
      'Frameworks, standards, platforms and architectures she has implemented and governed at enterprise scale.',
    contains: ['Frameworks & standards', 'Platforms & tooling', 'Reference architecture'],
  },
  {
    number: '09',
    name: 'Board Experience, Education & Civic Leadership',
    navLabel: 'Board & Education',
    path: '/board-education',
    summary:
      'Council and committee service, formal qualifications and certifications, and contribution beyond the organisation.',
    contains: ['Board & committee service', 'Education & certification', 'Civic leadership'],
  },
  {
    number: '10',
    name: 'Board Inquiry & Direct Contact Portal',
    navLabel: 'Contact Portal',
    path: '/contact',
    summary:
      'Direct contact channels, availability for NED and advisory engagement, and a structured board inquiry form.',
    contains: ['Direct contact', 'Availability', 'Inquiry form'],
  },
]

export function sectionByPath(path: string): SectionEntry | undefined {
  return sections.find((section) => section.path === path)
}

export function adjacentSections(path: string) {
  const index = sections.findIndex((section) => section.path === path)
  return {
    previous: index > 0 ? sections[index - 1] : undefined,
    next: index >= 0 && index < sections.length - 1 ? sections[index + 1] : undefined,
  }
}
